const baseURL = 'https://catalogo.elceibo.com/';

export default baseURL;
